const TemplateCard = ({ val, formData, setFormData }) => {
  return (
    <div
      value={val}
      onClick={() => setFormData({ ...formData, template: val })}
      className="cursor-pointer w-36"
    >
      <a
        className={`flex flex-col bg-white border shadow-sm rounded-xl hover:shadow-lg transition      /[.7] ${
          formData.template == val && "border-teal-500 border-2"
        }`}
      >
        <img
          className={`h-[17rem] rounded-lg object-cover border-b`}
          src={
            val === 0
              ? "https://bucket.pozivnica.hr/pozivnica/template-1.webp"
              : "https://bucket.pozivnica.hr/pozivnica/template-2.webp"
          }
          alt="Image Description"
        />
        <div className="p-4 md:p-5">
          <h5 className="text-sm text-gray-800   text-center">
            Predložak
          </h5>
        </div>
      </a>
    </div>
  );
};

export default TemplateCard;
